<div [class.sidebar-map]="lat && lng && !_markers">
  <div #gmap class="map-container" 
       [class.full-height]="fullHeight" 
       [class.use-in-collection]="useInCollection">
  </div>
</div>